export class Decorator {

    static rowUpdateStart = (row: HTMLElement, cell: HTMLElement) => {
        cell.classList.add("cell-loading");
        row.classList.add("row-loading");
    };

    static rowUpdateSuccess = (row: HTMLElement, cell: HTMLElement) => {

        cell.classList.remove("cell-loading");
        row.classList.remove("row-loading");

        cell.classList.add("cell-success-pulse");
        row.classList.add("row-success");

        setTimeout(() => cell.classList.remove("cell-success-pulse"), 1000);
        setTimeout(() => row.classList.remove("row-success"), 3000);
    }

    static rowUpdateException = (row: HTMLElement, cell: HTMLElement, message: string) => {
        cell.classList.remove("cell-loading");
        row.classList.remove("row-loading");

        alert(message);

        cell.classList.add("cell-error-shake");
        row.classList.add("row-error");

        setTimeout(() => cell.classList.remove("cell-error-shake"), 1500);
        setTimeout(() => row.classList.remove("row-error"), 3000);
    }

    static formUpdateStart = (form: HTMLDivElement) => {
        form.classList.add("form-loading");
    };

    static formUpdateSuccess = (form: HTMLElement) => {
        form.classList.remove("form-loading");
        form.classList.add("form-success");

        setTimeout(() => form.classList.remove("form-success"), 3000);
    };
    
    static formUpdateException = (form: HTMLElement, message: string) => {
        form.classList.remove("form-loading");
        form.classList.remove("form-error");
        alert(message);

        setTimeout(() => form.classList.remove("form-error"), 3000);
    };
}